// TestimonialsSection.js
import React, { useState, useEffect, useRef } from 'react';
import {
  ChevronDown,
  Linkedin,
  ArrowRight,
  Star,
  Sparkles,
  Zap,
  Award,
  TrendingUp,
  Eye
} from 'lucide-react';

// Given profiles data
const profiles = [
  { name: "Anjani Kumar", image: "assets/images/anjani.png", company: "Amazon", logo: "assets/images/amazonicon.png", linkedinUrl: "https://www.linkedin.com/in/anjani-kumar-singh-77337516a/", successStoryUrl: "https://logicmojo.com/anjani-data-science-review-success-story" },
  { name: "Praveen Kumar", image: "assets/images/praveen.jpg", company: "RevealIT Solutions", logo: "assets/images/companyLogo/revealIT.jpg", linkedinUrl:"https://www.linkedin.com/in/praveen-kumar-sjbit/", successStoryUrl: "https://logicmojo.com/pradeep-review-success-story" },
  { name: "Aman Lateef", image: "assets/images/Aman.jpg", company: "Infosys", logo: "assets/images/companyLogo/infosys.jpg", linkedinUrl:"https://www.linkedin.com/in/aman-lateef-336432130/", successStoryUrl: "https://logicmojo.com/aman-review-success-story"},
  { name: "Ashish Anand", image: "assets/images/Ashish1.jpg", company: "Data Scientist", logo: "assets/images/vmware.jpg", linkedinUrl:"https://www.linkedin.com/in/ashish-anand99", successStoryUrl: "https://logicmojo.com/ashish-review-success-story" },
  { name: "Asha Yadav", image: "assets/images/Asha.jpg", company: "Amazon", logo: "assets/images/amazonicon.png", linkedinUrl:"https://www.linkedin.com/in/asha-yadav-4a316148/", successStoryUrl: "https://technologyforlearners.com/review-by-asha-yadav-for-logicmojo-data-science-course/" },
  { name: "Himanshu Mittal", image: "assets/images/Himanshu.jpg", company: "Ripik.AI", logo: "assets/images/makemytrip.jpeg", linkedinUrl:"https://www.linkedin.com/in/himanshumittal13/", successStoryUrl: "https://logicmojo.com/himanshu-review-success-story" },
  { name: "Arpan Banerjee", image: "assets/images/arpan.jpg", company: "WalmartLabs", logo: "assets/images/walmarticon.png", linkedinUrl:"" },
  { name: "Shivank Agarwal", image: "assets/images/shivank.png", company: "Microsoft", logo: "assets/images/microsofticon.png", linkedinUrl:"" },
  { name: "Gunjan Yadu", image: "assets/images/gunjan.jpg", company: "BNY Mellon", logo: "", linkedinUrl:"https://www.linkedin.com/in/gunjan-yadu-6348b6183/" },
  { name: "Vamsi Karuturi", image: "assets/images/vamsi.png", company: "Walmart Labs", logo: "assets/images/walmarticon.png", linkedinUrl:"" },
  { name: "Piyush Mittal", image: "assets/images/piyush.png", company: "Microsoft", logo: "assets/images/microsofticon.png", linkedinUrl:"https://www.linkedin.com/in/piyush-mittal-56213989" },
  { name: "Salin Gupta", image: "assets/images/salin.png", company: "PayPal", logo: "assets/images/paypal.jpg", linkedinUrl:"" },
  { name: "Rishav", image: "assets/images/Rishav-Jha.png", company: "Adobe", logo: "assets/images/adobe.jpg", linkedinUrl:"" },
  { name: "Vignesh", image: "assets/images/Vignesh.jpg", company: "EXL", logo: "", linkedinUrl:"https://www.linkedin.com/in/vignesh-m-b3b630ab" },
  { name: "Siddharth Pande", image: "assets/images/sid1.png", company: "Microsoft", logo: "assets/images/microsoftlogo.jpg", linkedinUrl:"https://www.linkedin.com/in/siddharth-pande" },
  { name: "Mohammed Shirhaan", image: "assets/images/Mohammed-Shirhaan.png", company: "Walmart", logo: "assets/images/walmartlbslogo.jpg", linkedinUrl:"https://www.linkedin.com/in/mshirhaan/" },
  { name: "Amith Kumar", image: "assets/images/Amith.jpg", company: "Microsoft", logo: "assets/images/microsoftlogo.jpg", linkedinUrl:"https://www.linkedin.com/in/amith-kumar-56701322" },
  { name: "Rajnish Kumar", image: "assets/images/rajnish.jpg", company: "Flipkart", logo: "assets/images/flipcart.jpg", linkedinUrl:"https://www.linkedin.com/in/krrajnish/" },
  { name: "K Aniket Prusty", image: "assets/images/aniket.jpg", company: "Aster DM Healthcare", logo: "assets/images/asterDM.jpg", linkedinUrl:"" },
  { name: "Saksham Agarwal", image: "assets/images/saksham.jpg", company: "Accenture", logo: "assets/images/accenture.jpg", linkedinUrl:"" },
  { name: "Harini V", image: "assets/images/harini.jpg", company: "JPMorgan Chase", logo: "assets/images/jp-morgon.jpg", linkedinUrl:"" },
  { name: "Shishir Shashank", image: "assets/images/Shishir.jpg", company: "Meta", logo: "assets/images/meta.jpg", linkedinUrl:"" },
  { name: "Prem Raj", image: "assets/images/prem.jpg", company: "Infosys", logo: "assets/images/infosys.jpg", linkedinUrl:"https://www.linkedin.com/in/prem-raj-1b665b191/" },
  { name: "Samant Sagar", image: "assets/images/samant.jpg", company: "Invent Health Inc", logo: "assets/images/companyLogo/invest.jpg", linkedinUrl:"https://www.linkedin.com/in/samantsagar/" },
  { name: "Kishan Kumar Singh", image: "assets/images/kishan.jpg", company: "Cisco", logo: "assets/images/ciscologo.jpg", linkedinUrl:"https://www.linkedin.com/in/kishan-kumar-singh-484943141/" },
  { name: "Arpit Singh", image: "assets/images/arpit.png", company: "MakeMyTrip", logo: "assets/images/makemytrip.png", linkedinUrl:"https://www.linkedin.com/in/connect1arpit/" },
  { name: "Diwakar Choudhary", image: "assets/images/diwakar.png", company: "Walmart", logo: "assets/images/walmartlbslogo.jpg", linkedinUrl:"https://www.linkedin.com/in/diwakarchoudhary" },
  { name: "Sumit Upadhye", image: "assets/images/sumit.jpg", company: "Zoho", logo: "", linkedinUrl:"https://www.linkedin.com/in/sumitupadhye/" },
  { name: "Afnaan Rafique", image: "assets/images/afnaan.png", company: "paypal", logo: "", linkedinUrl:"https://www.linkedin.com/in/afnaan-rafique-b30149197/" },
  { name: "Priya Singh", image: "assets/images/priya1.png", company: "Cisco", logo: "assets/images/ciscologo.jpg", linkedinUrl:"https://www.linkedin.com/in/priyasingh2905/" },
  { name: "Aravind R", image: "assets/images/Aravind.jpg", company: "Virtusa", logo: "assets/images/companyLogo/virtusa.jpg", linkedinUrl:"https://www.linkedin.com/in/aravind-r-datascientist1995/" },
  { name: "Aravindo Swain", image: "assets/images/arvindo.jpg", company: "Microsoft", logo: "assets/images/microsoftlogo.jpg", linkedinUrl:"https://www.linkedin.com/in/aravindswain/" },
  { name: "Kailash Patel", image: "assets/images/mac/Khailash.jpg", company: "Fractal Analytics", logo: "assets/images/companyLogo/fractal.png", linkedinUrl:"" },
  { name: "Sanchit Taliyan", image: "assets/images/sanchit.jpg", company: "ANAROCK Technology", logo: "", linkedinUrl:"https://www.linkedin.com/in/sanchit-taliyan-568672158/" },
  { name: "Anjali Sharma", image: "assets/images/anjali.jpg", company: "Paytm", logo: "", linkedinUrl: "https://www.linkedin.com/in/anjali-sharma-0b1b62155/" },
  { name: "Mayank Kumar", image: "assets/images/mayank.jpg", company: "PTC", logo: "", linkedinUrl: "https://www.linkedin.com/in/mayank-kumar-a273a8116/" }
];

const TestimonialsSection = () => {
  const [activeCategory, setActiveCategory] = useState('All');
  const [mousePosition, setMousePosition] = useState({ x: 0, y: 0 });
  const [isVisible, setIsVisible] = useState(false);
  const [hoveredCard, setHoveredCard] = useState(null);
  const [time, setTime] = useState(0);

  const containerRef = useRef(null);
  const sectionRef = useRef(null);

  const categories = ['All', 'Career Transition', 'Career Gap', 'Career Upgrade', 'Career Launch'];
  const actualCategories = ['Career Transition', 'Career Gap', 'Career Upgrade', 'Career Launch'];
  const months = ['July', 'March', 'Nov', 'Apr', 'Dec', 'Oct', 'Jul', 'Aug', 'Jul', 'Oct', 'March', 'Dec'];

  // --- CONTENT MODIFIED AS PER REQUEST ---

  const aiRoles = [
    'Data Scientist',
    'Machine Learning Engineer',
    'AI Specialist',
    'NLP Engineer',
    'Computer Vision Scientist',
    'Lead Data Analyst',
    'MLOps Engineer',
    'AI Research Scientist'
  ];

// TestimonialsSection.js

const aiTestimonials = [
  (company) => (
    <>
      Logicmojo's{' '}
      <a href="https://logicmojo.com/best-data-science-courses-in-bangalore" target="_blank"  className="feature-link">
        Data Science
      </a>{' '}
      and{' '}
      <a href="https://logicmojo.com/artificial-intelligence-course/" target="_blank" className="feature-link">
        AI course
      </a>{' '}
      provided optimal training data. The curriculum's focus on{' '}
      <a href="https://logicmojo.com/what-is-deep-learning/" target="_blank" className="feature-link">
        deep learning
      </a>{' '}
      frameworks directly correlated to a 98% success rate in my deployment at{company}.
    </>
  ),
  (company) => (
    <>
      The course's modules on{' '}
      <a href="https://logicmojo.com/logistic-regression-machine-learning" target="_blank"  className="feature-link">
      Regression ML
      </a>{' '}
      and{' '}
      <a href="https://logicmojo.com/blog/what-is-model-deployment/" target="_blank"  className="feature-link">
      Artificial Neural Network
      </a>{' '}
      were critical for my career launch. This is the <a href="https://logicmojo.com/best-data-science-courses-in-bangalore" target="_blank"  className="feature-link">best data science course</a>.This knowledge enabled my transition to{' '}
      
        Machine Learning Engineer
      
      at {company}.
    </>


  ),
  (company) => (
    <>
     {/* Testimonial snippet */}
 I joined Logicmojo when I wasn’t sure about my next step. Their{' '}
<a
  href="https://logicmojo.com/regression-testing"
  target="_blank"
  
  className="feature-link"
>
Regression
</a>{' '}
and{' '}
<a
  href="https://logicmojo.com/big-data-analytics"
  target="_blank"
  
  className="feature-link"
>
big data analytics
</a>{' '}
made the math and <a href="https://logicmojo.com/blog/what-is-model-deployment/" target="_blank" className="feature-link">Machine Learning</a> clear, helped me build real Data Science and <a href="https://logicmojo.com/ai-projects" target="_blank" className="feature-link">AI projects</a>, and prepared me for interviews. That practical focus gave me the confidence and skills to switch into NLP, and I’m now delivering models in production at {company}.

    </>
  ),
  (company) => (
    <>
      {/* Review — Ashish Anand (Sigmatus Solutions) */}
<p>
  Its {" "}
  <a
    href="https://logicmojo.com/best-ai-courses"
    target="_blank"
    rel="noopener noreferrer"
    className="feature-link"
  >
   Best course for AI 
  </a>{" "}
  &amp; Data Science program. Logicmojo course gave me a clear, practical to develop Projects from scratch. The hands-on session in{" "}
  <a
    href="data-science-projects"
    target="_blank"
    
    className="feature-link"
  >
    data science projects
  </a>{" "}
  and{" "}
  <a
    href="https://logicmojo.com/convolutional-neural-network"
    target="_blank"
    
    className="feature-link"
  >
    neural networks
  </a>{" "}
  helped me connect theory with real project work. I did GitHub push along with <a  href="https://logicmojo.com/devops-interview-questions" target="_blank" className="feature-link">DevOps</a> pipelines.
  
</p>
    </>
  ),
  (company) => (
    <>
      The training on convolutional neural networks and <a href="https://logicmojo.com/agentic-ai-vs-generative-ai" target="_blank" className="feature-link">GenAI</a> was highly effective, leading to my function as a Computer Vision Scientist at {company}. This course helps candidate to from <a  href="https://logicmojo.com/best-ai-courses-software-engineers" target="_blank" className="feature-link">software engineer to AI</a> & Data science roles.
    </>
  ),
  (company) => (
    <>
      Query: Optimal path to a top-tier AI career. Result: Logicmojo. Their data-driven approach, from regression to deep learning, resulted in a career upgrade to Lead Data Analyst at {company}.
    </>
  ),
  (company) => (
    <>
      My learning algorithm was successfully retrained by Logicmojo's course. The structured data and expert guidance corrected my career trajectory, leading to a high-value position at {company}.
    </>
  ),
  (company) => (
    <>
      The AI course functions as a superior compiler for talent. It translated my potential into a high-performance feature set, which was immediately recognized by the team at {company}.
    </>
  )
];

  // Build testimonial objects with AI/Data Science focus
  const testimonials = profiles.map((profile, index) => {
    const day = (index % 28) + 1;
    const month = months[index % months.length];
    const year = 2024 - (index % 2);

    let daySuffix = 'th';
    if (day === 1 || day === 21 || day === 31) daySuffix = 'st';
    else if (day === 2 || day === 22) daySuffix = 'nd';
    else if (day === 3 || day === 23) daySuffix = 'rd';

    // Assign AI/DS roles and testimonials cyclically
    const role = aiRoles[index % aiRoles.length];
    const testimonialText = aiTestimonials[index % aiTestimonials.length](profile.company);

    return {
      id: index + 1,
      name: profile.name,
      role: `${role} at ${profile.company}`, // New AI/DS role
      company: profile.company,
      category: actualCategories[index % actualCategories.length],
      date: `${day}${daySuffix} ${month} ${year}`,
      image: profile.image,
      linkedinUrl: profile.linkedinUrl, // Pass linkedinUrl through
      testimonial: testimonialText, // New AI-like testimonial
      successStoryUrl: profile.successStoryUrl,
      rating: 5,
      salaryIncrease: `${140 + (index % 11) * 10}%`, // Higher salary increase for AI/DS roles
      previousCompany: 'Previous Role',
      currentCompany: profile.company,
      companyLogo: profile.logo
    };
  });

  // --- END OF CONTENT MODIFICATION ---

  // Filter based on selected category
  const filteredTestimonials =
    activeCategory === 'All'
      ? testimonials
      : testimonials.filter((t) => t.category === activeCategory);

  // Observe when section scrolls into view
  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => setIsVisible(entry.isIntersecting),
      { threshold: 0.1 }
    );
    if (sectionRef.current) observer.observe(sectionRef.current);
    return () => observer.disconnect();
  }, []);

  // Track mouse for animated background
  useEffect(() => {
    const handleMouseMove = (e) => {
      if (!containerRef.current) return;
      const rect = containerRef.current.getBoundingClientRect();
      setMousePosition({
        x: (e.clientX - rect.left) / rect.width,
        y: (e.clientY - rect.top) / rect.height
      });
    };
    const container = containerRef.current;
    if (container) {
      container.addEventListener('mousemove', handleMouseMove);
      return () => container.removeEventListener('mousemove', handleMouseMove);
    }
  }, []);

  // Increment time for background animations
  useEffect(() => {
    const interval = setInterval(() => setTime((prev) => prev + 1), 100);
    return () => clearInterval(interval);
  }, []);

  // Returns the gradient classes for a given category
  const getCategoryGradient = (category) => {
    const gradients = {
      'Career Upgrade': 'from-slate-600 via-blue-600 to-indigo-700',
      'Career Transition': 'from-blue-600 via-slate-500 to-gray-700',
      'Career Gap': 'from-gray-600 via-slate-600 to-blue-700',
      'Career Launch': 'from-indigo-600 via-blue-600 to-slate-700'
    };
    return gradients[category] || 'from-slate-600 via-blue-600 to-indigo-700';
  };

  return (
    <section
      ref={sectionRef}
      className="testimonials-section relative overflow-hidden"
    >
      {/** ——— Animated Background (unchanged) ——— */}
      <div
        ref={containerRef}
        className="testimonials-background"
        style={{
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          zIndex: -1,
          background: `
            radial-gradient(circle at ${mousePosition.x * 100}% ${mousePosition.y * 100}%, 
              rgba(71, 85, 105, 0.08) 0%, 
              rgba(30, 41, 59, 0.06) 30%, 
              rgba(15, 23, 42, 0.04) 60%, 
              transparent 80%
            ),
            linear-gradient(135deg, 
              rgba(2, 6, 23, 0.98) 0%, 
              rgba(15, 23, 42, 0.95) 50%, 
              rgba(2, 6, 23, 0.98) 100%
            )
          `
        }}
      >
        {[...Array(15)].map((_, i) => (
          <div
            key={`code-stream-${i}`}
            className="code-stream"
            style={{
              left: `${-20 + (time * 0.5 + i * 15) % 140}%`,
              top: `${10 + (i * 5.5) % 80}%`,
              animationDelay: `${i * 0.8}s`,
              opacity: 0.6
            }}
          >
            <div className="code-stream-content">
              <div className="code-indicator"></div>
              <div className="code-text">
                {i % 8 === 0 && (<span>model = tf.keras.Sequential([Dense(128, activation='relu')])</span>)}
                {i % 8 === 1 && (<span>X_train, X_test = train_test_split(data, test_size=0.2)</span>)}
                {i % 8 === 2 && (<span>optimizer = Adam(learning_rate=0.001, beta_1=0.9)</span>)}
                {i % 8 === 3 && (<span>loss = model.compile(loss='categorical_crossentropy')</span>)}
                {i % 8 === 4 && (<span>embeddings = transformer.encode(text_sequences)</span>)}
                {i % 8 === 5 && (<span>predictions = model.predict(X_test).argmax(axis=1)</span>)}
                {i % 8 === 6 && (<span>attention_weights = softmax(query @ key.T / sqrt(d_k))</span>)}
                {i % 8 === 7 && (<span>generated_text = gpt_model.generate(prompt, max_length=100)</span>)}
              </div>
            </div>
          </div>
        ))}
        {[...Array(8)].map((_, i) => (
          <div
            key={`ml-algo-${i}`}
            className="ml-algorithm"
            style={{
              left: `${-15 + (time * 0.2 + i * 20) % 130}%`,
              top: `${15 + (i * 10) % 70}%`,
              animationDuration: `${60 + i * 10}s`,
              opacity: 0.4
            }}
          >
            <div className="ml-algorithm-content">
              <div className="ml-algorithm-header">
                <div className="ml-algorithm-indicator"></div>
                <div className="ml-algorithm-title">
                  {i === 0 && 'NEURAL NETWORK TRAINING'}
                  {i === 1 && 'GRADIENT DESCENT OPTIMIZATION'}
                  {i === 2 && 'BACKPROPAGATION ALGORITHM'}
                  {i === 3 && 'TRANSFORMER ATTENTION'}
                  {i === 4 && 'CONVOLUTIONAL FEATURE EXTRACTION'}
                  {i === 5 && 'LSTM SEQUENCE PROCESSING'}
                  {i === 6 && 'RANDOM FOREST ENSEMBLE'}
                  {i === 7 && 'REINFORCEMENT Q-LEARNING'}
                </div>
              </div>
              <div className="ml-algorithm-code">
                {i === 0 && (
                  <>
                    <div className="code-line cyan">for epoch in range(epochs):</div>
                    <div className="code-line cyan ml-4">loss = forward_pass(X_batch)</div>
                    <div className="code-line cyan ml-4">gradients = backward_pass(loss)</div>
                    <div className="code-line cyan ml-4">optimizer.step(gradients)</div>
                  </>
                )}
                {i === 1 && (
                  <>
                    <div className="code-line green">θ = θ - α * ∇J(θ)</div>
                    <div className="code-line green">learning_rate = 0.001</div>
                    <div className="code-line green">momentum = 0.9</div>
                  </>
                )}
                {i === 2 && (
                  <>
                    <div className="code-line purple">∂L/∂w = ∂L/∂y * ∂y/∂w</div>
                    <div className="code-line purple">chain_rule_applied = True</div>
                    <div className="code-line purple">weights_updated = True</div>
                  </>
                )}
                {i === 3 && (
                  <>
                    <div className="code-line yellow">Attention(Q,K,V) = softmax(QK^T)V</div>
                    <div className="code-line yellow">multi_head_attention = True</div>
                    <div className="code-line yellow">context_vector_computed = True</div>
                  </>
                )}
                {i === 4 && (
                  <>
                    <div className="code-line pink">feature_maps = conv2d(input, kernel)</div>
                    <div className="code-line pink">pooling = max_pool2d(feature_maps)</div>
                    <div className="code-line pink">features_extracted = True</div>
                  </>
                )}
                {i === 5 && (
                  <>
                    <div className="code-line indigo">h_t = tanh(W_h * h_t-1 + W_x * x_t)</div>
                    <div className="code-line indigo">forget_gate = sigmoid(W_f * [h,x])</div>
                    <div className="code-line indigo">memory_updated = True</div>
                  </>
                )}
                {i === 6 && (
                  <>
                    <div className="code-line emerald">trees = [DecisionTree() for _ in range(100)]</div>
                    <div className="code-line emerald">prediction = majority_vote(trees)</div>
                    <div className="code-line emerald">ensemble_ready = True</div>
                  </>
                )}
                {i === 7 && (
                  <>
                    <div className="code-line orange">Q(s,a) = Q(s,a) + α[r + γ*max(Q(s',a'))]</div>
                    <div className="code-line orange">policy_improved = True</div>
                    <div className="code-line orange">reward_maximized = True</div>
                  </>
                )}
              </div>
              <div className="algorithm-progress">
                <div className="progress-header">
                  <span className="progress-label">Progress</span>
                  <span className="progress-value">{Math.floor(65 + Math.sin(time * 0.1 + i) * 25)}%</span>
                </div>
                <div className="progress-bar-container">
                  <div
                    className="progress-bar"
                    style={{ width: `${65 + Math.sin(time * 0.1 + i) * 25}%` }}
                  ></div>
                </div>
              </div>
            </div>
          </div>
        ))}
        {[...Array(12)].map((_, i) => (
          <div
            key={`formula-${i}`}
            className="formula-float"
            style={{
              left: `${-10 + (time * 0.3 + i * 25) % 120}%`,
              top: `${20 + (i * 6) % 60}%`,
              animationDelay: `${i * 1.2}s`,
              opacity: 0.3
            }}
          >
            <div className="formula-content">
              <div className="formula-text">
                {i === 0 && 'σ(x) = 1/(1+e^(-x))'}
                {i === 1 && 'ReLU(x) = max(0,x)'}
                {i === 2 && 'J(θ) = (1/2m)Σ(h_θ(x)-y)²'}
                {i === 3 && 'softmax(x_i) = e^(x_i)/Σe^(x_j)'}
                {i === 4 && '∇f = [∂f/∂x, ∂f/∂y, ∂f/∂z]'}
                {i === 5 && 'Adam: m_t = β₁m_{t-1} + (1-β₁)g_t'}
                {i === 6 && 'CrossEntropy = -Σy_i*log(ŷ_i)'}
                {i === 7 && 'Dropout: y = x * Bernoulli(p)'}
                {i === 8 && 'BatchNorm: (x-μ)/σ * γ + β'}
                {i === 9 && 'LSTM: f_t = σ(W_f[h_{t-1},x_t]+b_f)'}
                {i === 10 && 'Attention: α = exp(e)/Σexp(e)'}
                {i === 11 && 'GAN: min_G max_D V(D,G)'}
              </div>
            </div>
          </div>
        ))}
        {[...Array(20)].map((_, i) => (
          <div
            key={`data-flow-${i}`}
            className="data-flow-stream"
            style={{
              left: `${(i * 5) % 100}%`,
              top: `${-10 + (time * 2 + i * 20) % 120}%`,
              background: `linear-gradient(to bottom, transparent 0%, hsl(${200 + i * 15}, 70%, 60%) 50%, transparent 100%)`,
              animationDelay: `${i * 0.1}s`
            }}
          />
        ))}
      </div>

      {/** ——— Testimonials Content ——— */}
      <div className="testimonials-container relative z-10">
        <div className="testimonials-header">
          <div className={`header-content ${isVisible ? 'visible' : ''}`}>
            <div className="status-badge">
              <div className="status-indicator"></div>
              <span className="status-text">REAL SUCCESS STORIES</span>
              <div className="status-dots">
                {[...Array(3)].map((_, idx) => (
                  <div
                    key={idx}
                    className="status-dot"
                    style={{ animationDelay: `${idx * 0.2}s` }}
                  />
                ))}
              </div>
              <Eye className="status-icon" />
              <div className="status-background"></div>
            </div>
            <h2 className="main-title">
              <span className="title-text">2. Students Testimony</span>
              <div className="title-glow-1"></div>
              <div className="title-glow-2"></div>
              <div className="title-sparkles">
                {[...Array(8)].map((_, idx) => (
                  <Sparkles
                    key={idx}
                    className="sparkle"
                    style={{
                      left: `${20 + Math.random() * 60}%`,
                      top: `${20 + Math.random() * 60}%`,
                      animationDelay: `${Math.random() * 1}s`
                    }}
                  />
                ))}
              </div>
            </h2>
            <p className="subtitle">
              Witness the incredible career transformations of our students
              <span className="rocket-emoji">🚀</span>
            </p>
          </div>
        </div>

        <div className={`category-filter ${isVisible ? 'visible' : ''}`}>
          {categories.map((category, index) => (
            <button
              key={category}
              onClick={() => setActiveCategory(category)}
              className={`category-btn ${activeCategory === category ? 'active' : ''}`}
              style={{
                animationDelay: `${index * 0.1}s`,
                background:
                  activeCategory === category
                    ? `linear-gradient(
                        135deg,
                        rgba(71, 85, 105, 0.4) 0%,
                        rgba(30, 41, 59, 0.3) 50%,
                        rgba(15, 23, 42, 0.2) 100%
                      )`
                    : 'rgba(255, 255, 255, 0.03)'
              }}
            >
              <span className="category-btn-content">
                {category}
                {activeCategory === category && (
                  <div className="category-indicators">
                    <ChevronDown className="chevron-icon" />
                    <Zap className="zap-icon" />
                  </div>
                )}
              </span>
              <div className="category-btn-hover"></div>
              <div className="category-btn-blur"></div>
              {activeCategory === category && (
                <>
                  <div className="category-btn-active-bg"></div>
                  <div className="category-btn-active-glow"></div>
                </>
              )}
            </button>
          ))}
        </div>

        {/** Horizontal scrolling container (unchanged) **/}
        <div className="testimonials-grid flex flex-nowrap overflow-x-auto scroll-smooth py-4 px-1 custom-scrollbar snap-x snap-mandatory">
          {filteredTestimonials.slice(0, 24).map((testimonial, index) => (
            <div
              key={testimonial.id}
              className={`testimonial-card ${isVisible ? 'visible' : ''} flex-shrink-0 w-80 snap-start h-full`}
              style={{ animationDelay: `${800 + index * 200}ms` }}
              onMouseEnter={() => setHoveredCard(testimonial.id)}
              onMouseLeave={() => setHoveredCard(null)}
            >
              <div className="card-wrapper">
                <div className="card-main">
                  <div className={`card-background bg-gradient-to-br ${getCategoryGradient(testimonial.category)}`}></div>

                  {/** — CATEGORY BADGE REMOVED — **/}
                  {/** We will display the category text instead inside the header below. **/}

                  <div className="card-content">
                    {/** — REWRITTEN HEADER (Date, Category, Stars), ALL CENTERED — **/}
                    <div className="card-header">
                      {testimonial.date && (
                        <div className="date-badge">
                          <span className="date-text">{testimonial.date}</span>
                        </div>
                      )}

                      {/** Category text now in the center **/}
                      <div className="category-text">
                        {testimonial.category}
                      </div>

                      {/** 5-star rating centered **/}
                      <div className="rating-stars">
                        {[...Array(testimonial.rating)].map((_, idx) => (
                          <Star
                            key={idx}
                            className="star-icon"
                            style={{ animationDelay: `${idx * 0.1}s` }}
                          />
                        ))}
                      </div>
                    </div>

                    {/** — PROFILE SECTION (Avatar + LinkedIn Icon) — **/}
                    <div className="profile-section">
                      <div className="avatar-container">
                        <div
                          className={`avatar bg-gradient-to-br ${getCategoryGradient(testimonial.category)}`}
                          style={{
                            backgroundImage: `url(${testimonial.image})`,
                            backgroundSize: 'cover',
                            backgroundPosition: 'center',
                            color: 'transparent'
                          }}
                        >
                          {!testimonial.image &&
                            testimonial.name
                              .split(' ')
                              .map((n) => n[0])
                              .join('')}
                          <div className="avatar-ring-1"></div>
                          <div className="avatar-ring-2"></div>
                          <div className="avatar-ring-3"></div>
                        </div>

                         <a 
                          href={testimonial.linkedinUrl} 
                          target="_blank" 
                           
                          className="linkedin-badge"
                          aria-label={`${testimonial.name}'s LinkedIn Profile`}
                        >
                          <Linkedin className="linkedin-icon" />
                          <div className="linkedin-glow"></div>
                        </a>

                      </div>
                      <div className="profile-info">
                        <h3 className="profile-name">{testimonial.name}</h3>
                        <p className="profile-role">{testimonial.role}</p>
                        {testimonial.company && <p className="profile-company">{testimonial.company}</p>}
                        <div className="salary-badge">
                          <TrendingUp className="trending-icon" />
                          <span className="salary-text">+{testimonial.salaryIncrease}</span>
                        </div>
                      </div>
                    </div>

                    {/** — TESTIMONIAL TEXT — **/}
                    <div className="testimonial-text">
                      <div className="quote-left">"</div>
                      <div className="testimonial-content">
                        <p className="testimonial-paragraph">{testimonial.testimonial}</p>
                      </div>
                      <div className="quote-right">"</div>
                    </div>

                    {/** — CAREER PROGRESSION (unchanged) — **/}
                    {testimonial.previousCompany && testimonial.currentCompany && (
                      <div className="career-progression">
                        <div className="career-item">
                          <div className="career-label">Pre Logicmojo</div>
                          <div className="career-company">{testimonial.previousCompany}</div>
                        </div>
                        <div className="career-arrow-container">
                          <div className={`career-arrow bg-gradient-to-r ${getCategoryGradient(testimonial.category)}`}>
                            <ArrowRight className="arrow-icon" />
                          </div>
                          <div className="career-arrow-glow"></div>
                        </div>
                        <div className="career-item">
                          <div className="career-label">Post Logicmojo</div>
                          <div className="career-company">{testimonial.currentCompany}</div>
                        </div>
                      </div>
                    )}

                    {/** — “Read More” Button (unchanged) — **/}
                    <a 
                      href={testimonial.successStoryUrl}
                      target="_blank"
                      
                      className="read-more-btn"
                    >
                      <span className="read-more-content">
                        Read More
                        <ArrowRight className="read-more-arrow" />
                      </span>
                      <div className="read-more-bg-1"></div>
                      <div className="read-more-bg-2"></div>
                      <div className="read-more-bg-3"></div>
                    </a>
                  </div>

                  <div className="card-border-glow"></div>
                  {hoveredCard === testimonial.id && (
                    <>{/* — hover-particles removed — */}</>
                  )}
                </div>

                <div className={`card-shadow bg-gradient-to-br ${getCategoryGradient(testimonial.category)}`}></div>
              </div>
            </div>
          ))}
        </div>

        <div className={`cta-section ${isVisible ? 'visible' : ''}`}>
          <div className="cta-container1">
            
          <button
  className="cta-btn"
  onClick={() => window.location.href = "https://logicmojo.com/success-story"}
>
  <span className="cta-content">
    <Award className="cta-award" />
    Check Success Story
    <ArrowRight className="cta-arrow" />
  </span>
  <div className="cta-bg-1"></div>
  <div className="cta-bg-2"></div>
  <div className="cta-bg-3"></div>
  <div className="cta-particles">
    {[...Array(25)].map((_, idx) => (
      <div
        key={idx}
        className="cta-particle"
        style={{
          left: `${10 + Math.random() * 80}%`,
          top: `${10 + Math.random() * 80}%`,
          animationDelay: `${Math.random() * 0.5}s`
        }}
      />
    ))}
  </div>
</button>

            <div className="cta-orbiting">
              {[...Array(8)].map((_, idx) => (
                <div
                  key={idx}
                  className="cta-orbit"
                  style={{
                    left: `${20 + Math.cos((idx * 45) * Math.PI / 180) * 40}%`,
                    top: `${20 + Math.sin((idx * 45) * Math.PI / 180) * 40}%`,
                    animationDelay: `${idx * 0.2}s`,
                    animationDuration: `${1 + Math.random()}s`
                  }}
                />
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default TestimonialsSection;